// The dictation endpoint, with who it is for. POST /transcribe meters the
// audio against the caller's team, and a row with no customer never reaches a
// team, so every browser dictation call carries the selected customer (and job
// when one is selected) the way the other calls do.
import { API_BASE_URL } from '../constants/system'
import { useAccount } from './useAccount'

export function buildTranscribeEndpoint(customer?: string | null, job?: string | null): string {
  const params = new URLSearchParams()
  if (customer) params.set('customer', customer)
  if (job) params.set('job', job)
  const qs = params.toString()
  return `${API_BASE_URL}/transcribe${qs ? `?${qs}` : ''}`
}

export default function useTranscribeEndpoint(): string {
  const account = useAccount()
  return buildTranscribeEndpoint(account.customer?.name, account.job?.name)
}
